let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("csjms")).then(() => parcelRequire('21RiV'));